import * as React from "react";
import styled from "styled-components";
import CountBadge from "./CountBadge";
const Listing = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const ListingWithCount = ({ count, listing }) => /* @__PURE__ */ React.createElement(Listing, { title: String(listing) }, /* @__PURE__ */ React.createElement(CountBadge, { count }), " ", listing);
export default ListingWithCount;
